/* External */
import { call, put, takeEvery } from 'redux-saga/effects';

/* ActionTypes */
import {
  FETCH_CONTENT_BY_ID,
  FETCH_VOD_CONTENT_MOVIE_PROGRESS,
} from './actionTypes';

/* Actions */
import { addToEntities } from '../utils/actions';

/* Sagas */
import { requestSaga } from '../requests/sagas';
import { authenticatedSaga } from '../utils/sagas';

/* Services */
import backendService from '../../services/backendService';

function fetchContentByIdService({ contentId }) {
  return backendService.content.v1.getAssetDetail(contentId);
}

function* fetchContentByIdSaga(action) {
  try {
    const response = yield call(requestSaga, fetchContentByIdService, action);
    if (response) {
      const { normalizedData: { entities } } = response;
      yield put(addToEntities(entities));
    }
  } catch (error) {
    console.error('contents>fetchContentByIdSaga', error);
  }
}

function* fetchContentById() {
  yield takeEvery(FETCH_CONTENT_BY_ID, authenticatedSaga(fetchContentByIdSaga));
}

function fetchVodContentMovieProgressService(params) {
  return backendService.experience.v3.getContinueWatchingMovie(params);
}

function* fetchVodContentMovieProgressSaga(action) {
  try {
    const response = yield call(requestSaga, fetchVodContentMovieProgressService, action);

    if (response) {
      const { normalizedData: { entities = {} } = {} } = response;
      yield put(addToEntities(entities));
    }
  } catch (error) {
    console.error('vodContents>fetchVodContentProgressSaga', error);
  }
}

function* fetchVodContentMovieProgress() {
  yield takeEvery(
    FETCH_VOD_CONTENT_MOVIE_PROGRESS,
    authenticatedSaga(fetchVodContentMovieProgressSaga),
  );
}

export default [
  fetchContentById,
  fetchVodContentMovieProgress,
];
